import { storeStructure } from '../store/reducers';
import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
export default {
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: false,
  canRemove: false,
  emptyMessage: " No App References Found",
  fields: [
    {
      attributeName: 'mediaName',
      label: 'Media Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of media',
      canOrder: false,
      canFilter: false,
    },
    {
      attributeName: 'mediaLink',
      label: 'Link to Content',
      type: FormInputTypes.LINK,
      icon: IconType.LINK,
      helpText: 'Link to the app / room edit form',
      canOrder: false,      
      canFilter: false,
    },
  ],
};
